<script setup>
import { ref, onMounted } from 'vue';
import { CountryService } from '../services/CountryService.js';

const props = defineProps({
    modelValue: { type: String, default: '' },
    placeholder: { type: String, default: 'Unesite broj' }
});

const emit = defineEmits(['update:modelValue']);

const kodovi = ref([]);
const odabraniKod = ref(null);
const lokalnibroj = ref('');
const ucitavanje = ref(false);
const greska = ref('');

onMounted(async () => {
    ucitavanje.value = true;
    try {
        const countries = await CountryService.getCountries();

        kodovi.value = countries
            .filter((c) => c.dialCode)
            .map((c) => ({
                label: `${c.name} (${c.dialCode})`,
                value: c.dialCode
            }));

        // Pokušaj parsirati postojeću vrijednost
        if (props.modelValue) {
            const sviKodovi = countries
                .map((c) => c.dialCode)
                .filter(Boolean)
                .sort((a, b) => b.length - a.length); // od najduljeg
            const pronadeni = sviKodovi.find((k) => props.modelValue.startsWith(k));
            if (pronadeni) {
                odabraniKod.value = pronadeni;
                lokalnibroj.value = props.modelValue.slice(pronadeni.length);
            } else {
                odabraniKod.value = '+382';
                lokalnibroj.value = props.modelValue;
            }
        } else {
            odabraniKod.value = '+382'; // default CG
        }
    } catch (e) {
        console.error('Greška pri dohvatu pozivnih brojeva:', e);
        odabraniKod.value = '+382';
        if (props.modelValue) lokalnibroj.value = props.modelValue;
    } finally {
        ucitavanje.value = false;
    }
});

// Države kod kojih je vodeća 0 dio broja i u međunarodnom formatu (Italija, San Marino, Obala Slonovače).
const KODOVI_SA_NULOM = ['+39', '+378', '+225'];

// Lokalni dio bez razmaka na krajevima i bez vodećih nula
// (npr. "067 123 456" uz +382 postaje "+38267 123 456").
const normalizujLokalni = (broj, kod) => {
    const t = (broj || '').trim();
    return KODOVI_SA_NULOM.includes(kod) ? t : t.replace(/^0+/, '');
};

const azuriraj = () => {
    const lokalni = normalizujLokalni(lokalnibroj.value, odabraniKod.value);
    if (lokalni && !odabraniKod.value) {
        greska.value = 'Molimo odaberite pozivni broj države.';
    } else {
        greska.value = '';
    }
    // Bez lokalnog broja ne šaljemo samo pozivni broj (npr. "+382").
    const pun = !lokalni ? '' : odabraniKod.value ? `${odabraniKod.value}${lokalni}` : lokalni;
    emit('update:modelValue', pun);
};
</script>

<template>
    <div class="phone-input-wrapper">
        <div class="phone-input-row">
            <Dropdown
                v-model="odabraniKod"
                :options="kodovi"
                optionLabel="label"
                optionValue="value"
                placeholder="+..."
                filter
                :loading="ucitavanje"
                class="phone-code-dropdown"
                @change="azuriraj"
            />
            <InputText
                v-model="lokalnibroj"
                :placeholder="placeholder"
                class="phone-number-input"
                @input="azuriraj"
            />
        </div>
        <small v-if="greska" class="phone-error">{{ greska }}</small>
    </div>
</template>

<style scoped>
.phone-input-wrapper {
    width: 100%;
}

.phone-input-row {
    display: flex;
    gap: 8px;
}

.phone-code-dropdown {
    width: 260px;
    flex-shrink: 0;
}

.phone-number-input {
    flex: 1;
    min-width: 0;
}

.phone-error {
    color: #dc2626;
    font-size: 0.8rem;
    margin-top: 4px;
    display: block;
}
</style>
